import Box from '@mui/material/Box'

const Heading = ({ text }) => (
  <Box
    sx={{
      fontStyle: 'italic',
      fontWeight: 700,
      mt: 4,
      mb: 1,
    }}
  >
    {text}
  </Box>
)

export default Heading
